import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const API_URL = "https://api.garturbo.com";

const ImageCarousel = () => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const res = await fetch(`${API_URL}/banner/fetchBanner`);
        const data = await res.json();
        setBanners(data.data?.banners || []);
      } catch (err) {
        console.error("Failed to fetch banners:", err);
      }
    };
    fetchBanners();
  }, []);

  if (banners.length === 0) return null;

  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 5000 }}
        loop
        pagination={{ clickable: true }}
        spaceBetween={0}
        slidesPerView={1}
        style={{ width: "100%" }}
      >
        {banners.map((src, index) => (
          <SwiperSlide key={index}>
            <img
              src={`${API_URL}${src}`}
              alt={`Banner ${index + 1}`}
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "300px", // max height guard
                objectFit: "cover",
                borderRadius: "6px",
                display: "block",
                margin: "0 auto",
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageCarousel;
